import React, { useState } from "react";
import ElementorAccordion from "../components/ElementorAccordion";


export const Services = () => {
  const [activeKey, setActiveKey] = useState(null);

  const toggleAccordion = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };
  const accordionData = [
    {
      id: 1,
      title: "Bulk sacks (25kg, 50kg, 1MT)",
      content:
        "Ideal for millers, distributors, and wholesale buyers who require efficiency in handling and storage.",
    },
    {
      id: 2,
      title: "Retail-Ready and custom-branded packaging",
      content:
        "Designed for consumer markets, offering private-label options that strengthen your brand presence.",
    },
    {
      id: 3,
      title: "Multilingual and region-compliant labeling",
      content:
        "Packaging and labels are adapted to meet regulatory standards and language needs across different markets.",
    },
  ];
  const accordionData2 = [
    {
      id: 4,
      title: "Competitive pricing from global markets",
      content:
        "Our international supplier network allows us to offer market-driven rates that keep buyers competitive",
    },
    {
      id: 5,
      title: "Verified sourcing from approved exporters",
      content:
        "Every trade is backed by government-certified partners to ensure compliance and quality.",
    },
    {
      id: 6,
      title: "Seasonal flexibility and multi-origin supply",
      content:
        "We provide diverse sourcing options across harvest seasons and regions to ensure consistent supply.",
    },
  ];
  const accordionData3 = [
    {
      id: 7,
      title: "Sea freight (Bulk and Containerized)",
      content:
        "Flexible shipping options tailored for both large-scale bulk consignments and smaller containerized loads.",
    },
    {
      id: 8,
      title: "Full export documentation",
      content:
        "Complete paperwork support including Certificates of Origin, Bills of Lading, commercial invoices, and inspection reports.",
    },
    {
      id: 9,
      title: "CIF and FOB delivery options",
      content:
        "Customized shipping terms to match buyer preferences, covering both cost-inclusive (CIF) and free-on-board (FOB) arrangements.",
    },
  ];
  const accordionData4 = [
    {
      id: 10,
      title: "Commodity sales contract drafting and support",
      content:
        "Guidance on structuring contracts to secure reliable grain supplies",
    },
    {
      id: 11,
      title: "Procurement planning based on market trends",
      content:
        "Tailored supply plans aligned with changing market dynamics.",
    },
    {
      id: 12,
      title: "Documentation aligned with local import rules",
      content:
        "Full compliance assistance with regional and international trade regulations.",
    },
  ];
      const accordionData5 = [
    {
      id: 13,
      title: "Global Grain Market Updates",
      content:
        "Regular analysis of price movements, harvest outlooks, and trade policies.",
    },
    {
      id: 14,
      title: "Country-Specific Sourcing Advice",
      content:
        "Insights into origin-based advantages and risks for each commodity",
    },
    {
      id: 15,
      title: "Risk Mitigation Through Diversified Origin Planning",
      content:
        "Secure procurement strategies by sourcing from multiple global origins.",
    },
  ];
    const accordionData6 = [
    {
      id: 16,
      title: "Shipment Verification and Documentation Review",
      content:
        "Assistance in cross-checking all paperwork for accuracy and compliance.",
    },
    {
      id: 17,
      title: "Support with Re-Orders and Adjustments",
      content:
        "Flexible solutions to adapt to evolving buyer needs.",
    },
    {
      id: 18,
      title: "Issue Resolution and Long-Term Collaboration",
      content:
        "Dedicated after-sales service to maintain trust and strengthen partnerships.",
    },
  ];
  return (
   
    <div className="page_content_wrap pt-0">
      <div className="content_wrap_fullscreen">

        <div className="content">
          {/* <section className='container-paddingtop'></section> */}
          {/* services grow */}
          <div className='bgcolor_servicetop'>
            <div className="container py-5 py-sm-about-0">

              <div className="min-h-screen bg-background">
                <section className="container mx-auto px-4 py-16 md:py-24 lg:py-32 py-2">
                  <div className="flex flex-col items-center justify-center text-center">
                    <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground mb-6 md:mb-8">
                      Our Services
                    </h1>
                    <i className="fa-solid fa-chevron-down"></i>

                  </div>
                </section>
              </div>
            </div>
          </div>
          <span
            id="content_skip_link_anchor"
            className="agricola_skip_link_anchor"
          />
          <article
            id="post-17757"
            className="post_item_single post_type_page post-17757 page type-page status-publish hentry"
          >
            <div className="post_content entry-content">
              <div
                data-elementor-type="wp-page"
                data-elementor-id={17757}
                className="elementor elementor-17757"
              >
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-4ce31a7 scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="4ce31a7"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-07fa92e sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="07fa92e"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-ae1467c sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="ae1467c"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-33ab888 elementor-section-content-middle scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="33ab888"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-no">
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-c7e6d73 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="c7e6d73"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-3ae81ed sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="3ae81ed"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container elementor-widget-services">
                            <img
                              loading="lazy"
                              decoding="async"
                              width={780}
                              height={963}
                              src="/img/services/service2.jpg"
                              className="attachment-full size-full wp-image-19353"
                              alt="service"
                              srcSet="/img/services/service2.jpg"
                              sizes="(max-width: 780px) 100vw, 780px"
                            />{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5e1ce9b sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="5e1ce9b"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-74f6442 sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="74f6442"
                          data-element_type="widget"
                          data-widget_type="trx_sc_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="sc_title color_style_dark sc_title_default">

                              <h1 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag" style={{ fontSize: "2.5rem" }}>
                                <span className="sc_item_title_text">
                                  Global Sourcing Of Agro Commodities
                                </span>
                              </h1>
                              <p className="pt-2">
                                We source bulk grains and specialty products from trusted producers across major agricultural regions such as Russia, India, the USA, Pakistan, and China.
                              </p>

                            </div>{" "}
                          </div>
                        </div>

                        <div
                          className="elementor-element elementor-element-df8fe06 bordered sc_fly_static elementor-widget elementor-widget-accordion trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="df8fe06"
                          data-element_type="widget"
                          data-widget_type="accordion.default"
                        >
                          <ElementorAccordion accordionData={accordionData2} />

                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-ebd9e56 scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="ebd9e56"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d14a7f9 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="d14a7f9"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-7988aad sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="7988aad"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-33ab888 elementor-section-content-middle scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="33ab888"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-no">
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5e1ce9b sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited order-1"
                      data-id="5e1ce9b"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-74f6442 sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="74f6442"
                          data-element_type="widget"
                          data-widget_type="trx_sc_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="sc_title color_style_dark sc_title_default">

                              <h1 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag" style={{ fontSize: "2.5rem" }}>
                                <span className="sc_item_title_text">
                                  Custom Packaging and Labeling
                                </span>
                              </h1>
                              <p className="pt-2">
                                We provide tailored packaging solutions to meet customer requirements, from large-scale bulk orders to private-label retail products.
                              </p>
                            </div>{" "}
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-5f63acc sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="5f63acc"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-df8fe06 bordered sc_fly_static elementor-widget elementor-widget-accordion trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="df8fe06"
                          data-element_type="widget"
                          data-widget_type="accordion.default"
                        >
                          <ElementorAccordion accordionData={accordionData} />

                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-c7e6d73 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited order-2"
                      data-id="c7e6d73"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-3ae81ed sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="3ae81ed"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container elementor-widget-services">
                            <img
                              loading="lazy"
                              decoding="async"
                              width={780}
                              height={963}
                              src="/img/services/service1.jpg"
                              className="attachment-full size-full wp-image-19353"
                              alt=""
                              srcSet="/img/services/service1.jpg"
                              sizes="(max-width: 780px) 100vw, 780px"
                            />{" "}
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-ebd9e56 scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="ebd9e56"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d14a7f9 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="d14a7f9"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-7988aad sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="7988aad"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>


                {/* 2 */}



                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-4ce31a7 scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="4ce31a7"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-07fa92e sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="07fa92e"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-ae1467c sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="ae1467c"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-33ab888 elementor-section-content-middle scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="33ab888"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-no">
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-c7e6d73 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="c7e6d73"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-3ae81ed sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="3ae81ed"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container elementor-widget-services">
                            <img
                              loading="lazy"
                              decoding="async"
                              width={780}
                              height={963}
                              src="/img/services/service3.jpg"
                              className="attachment-full size-full wp-image-19353"
                              alt=""
                              srcSet="/img/services/service3.jpg"
                              sizes="(max-width: 780px) 100vw, 780px"
                            />{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5e1ce9b sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="5e1ce9b"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-74f6442 sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="74f6442"
                          data-element_type="widget"
                          data-widget_type="trx_sc_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="sc_title color_style_dark sc_title_default">
                              {/* <span className="sc_item_subtitle sc_title_subtitle sc_item_subtitle_above sc_item_title_style_default">
                            Sharing Experience
                          </span> */}
                              <h1 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag" style={{ fontSize: "2.5rem" }}>
                                <span className="sc_item_title_text">
                                  Export Logistics and Documentation
                                </span>
                              </h1>
                              <p className="pt-2">
                                Our dedicated logistics team oversees the entire export process, ensuring shipments are delivered smoothly and on time from Oman’s key ports such as Sohar and Salalah.
                              </p>
                            </div>{" "}
                          </div>
                        </div>

                        <div
                          className="elementor-element elementor-element-df8fe06 bordered sc_fly_static elementor-widget elementor-widget-accordion trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="df8fe06"
                          data-element_type="widget"
                          data-widget_type="accordion.default"
                        >
                          <ElementorAccordion accordionData={accordionData3} />

                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-ebd9e56 scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="ebd9e56"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d14a7f9 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited "
                      data-id="d14a7f9"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-7988aad sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="7988aad"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-33ab888 elementor-section-content-middle scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="33ab888"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-no">
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5e1ce9b sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited order-1"
                      data-id="5e1ce9b"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-74f6442 sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="74f6442"
                          data-element_type="widget"
                          data-widget_type="trx_sc_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="sc_title color_style_dark sc_title_default">

                              <h1 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag" style={{ fontSize: "2.5rem" }}>
                                <span className="sc_item_title_text">
                                  Contract Management & Trade Advisory
                                </span>
                              </h1>
                                                            <p className="pt-2">
                                We support clients in building strong procurement strategies through forward contracts and customized supply solutions while ensuring compliance with GCC and Asian import regulations.
                              </p>
                            </div>{" "}
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-5f63acc sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="5f63acc"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-df8fe06 bordered sc_fly_static elementor-widget elementor-widget-accordion trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited order-2"
                          data-id="df8fe06"
                          data-element_type="widget"
                          data-widget_type="accordion.default"
                        >
                          <ElementorAccordion accordionData={accordionData4} />

                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-c7e6d73 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="c7e6d73"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-3ae81ed sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="3ae81ed"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container elementor-widget-services">
                            <img
                              loading="lazy"
                              decoding="async"
                              width={780}
                              height={963}
                              src="/img/services/service4.jpg"
                              className="attachment-full size-full wp-image-19353"
                              alt=""
                              srcSet="/img/services/service4.jpg"
                              sizes="(max-width: 780px) 100vw, 780px"
                            />{" "}
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </section>
                
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-ebd9e56 scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="ebd9e56"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d14a7f9 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="d14a7f9"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-7988aad sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="7988aad"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>




                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-4ce31a7 scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="4ce31a7"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-07fa92e sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="07fa92e"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-ae1467c sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="ae1467c"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-33ab888 elementor-section-content-middle scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="33ab888"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-no">
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-c7e6d73 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="c7e6d73"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-3ae81ed sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="3ae81ed"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container elementor-widget-services">
                            <img
                              loading="lazy"
                              decoding="async"
                              width={780}
                              height={963}
                              src="/img/services/service5.jpg"
                              className="attachment-full size-full wp-image-19353"
                              alt=""
                              srcSet="/img/services/service5.jpg"
                              sizes="(max-width: 780px) 100vw, 780px"
                            />{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5e1ce9b sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="5e1ce9b"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-74f6442 sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="74f6442"
                          data-element_type="widget"
                          data-widget_type="trx_sc_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="sc_title color_style_dark sc_title_default">
                              {/* <span className="sc_item_subtitle sc_title_subtitle sc_item_subtitle_above sc_item_title_style_default">
                            Sharing Experience
                          </span> */}
                              <h1 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag" style={{ fontSize: "2.5rem" }}>
                                <span className="sc_item_title_text">
Commodity Sales Contract Drafting and Support  
                              </span>
                              </h1>
                              <p className="pt-2">
                               We provide real-time intelligence to help buyers make informed sourcing decisions and mitigate risks in a shifting global grain market.
                              </p>
                            </div>{" "}
                          </div>
                        </div>

                        <div
                          className="elementor-element elementor-element-df8fe06 bordered sc_fly_static elementor-widget elementor-widget-accordion trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="df8fe06"
                          data-element_type="widget"
                          data-widget_type="accordion.default"
                        >
                          <ElementorAccordion accordionData={accordionData5} />

                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-ebd9e56 scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="ebd9e56"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d14a7f9 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="d14a7f9"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-7988aad sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="7988aad"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-33ab888 elementor-section-content-middle scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="33ab888"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-no">
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5e1ce9b sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited order-1"
                      data-id="5e1ce9b"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-74f6442 sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited "
                          data-id="74f6442"
                          data-element_type="widget"
                          data-widget_type="trx_sc_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="sc_title color_style_dark sc_title_default">

                              <h1 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag" style={{ fontSize: "2.5rem" }}>
                                <span className="sc_item_title_text">
                                  Post-Sale Support and Relationship Management
                                </span>
                              </h1>
                                                            <p className="pt-2">
                                Our partnership continues beyond delivery, with ongoing support to ensure seamless transactions and long-term collaboration.
                              </p>
                            </div>{" "}
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-5f63acc sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited order-1"
                          data-id="5f63acc"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-df8fe06 bordered sc_fly_static elementor-widget elementor-widget-accordion trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited order-2"
                          data-id="df8fe06"
                          data-element_type="widget"
                          data-widget_type="accordion.default"
                        >
                          <ElementorAccordion accordionData={accordionData6} />

                        </div>
                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-c7e6d73 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited order-2"
                      data-id="c7e6d73"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-3ae81ed sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited "
                          data-id="3ae81ed"
                          data-element_type="widget"
                          data-widget_type="image.default"
                        >
                          <div className="elementor-widget-container elementor-widget-services">
                            <img
                              loading="lazy"
                              decoding="async"
                              width={780}
                              height={963}
                              src="/img/services/service6.jpg"
                              className="attachment-full size-full wp-image-19353"
                              alt=""
                              srcSet="/img/services/service6.jpg"
                              sizes="(max-width: 780px) 100vw, 780px"
                            />{" "}
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </section>
                
                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-ebd9e56 scheme_default elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="ebd9e56"
                  data-element_type="section"
                  data-settings='{"background_background":"classic"}'
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d14a7f9 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="d14a7f9"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-7988aad sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="7988aad"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>



                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-955794b elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="955794b"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae84a01 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="ae84a01"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-7dcaa8d sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="7dcaa8d"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-651fb5b elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="651fb5b"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-836be81 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="836be81"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-3dd68bb sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="3dd68bb"
                          data-element_type="widget"
                          data-widget_type="trx_sc_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="sc_title color_style_dark sc_title_default">
                              {/* <span className="sc_item_subtitle sc_title_subtitle sc_item_subtitle_above sc_item_title_style_default">
Why Clients Choose Our Services
                              </span> */}
                              <h1 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                                <span className="sc_item_title_text">
                                  Why Clients Choose Our Services
                                </span>
                              </h1>
                            </div>{" "}
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-ace4c05 sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="ace4c05"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-35ebeba sc_fly_static elementor-widget elementor-widget-text-editor trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="35ebeba"
                          data-element_type="widget"
                          data-widget_type="text-editor.default"
                        >
                          <div className="elementor-widget-container">
                            <ul>
                              <li>Export-compliant agricultural trade from Oman</li>
                              <li>End-to-end service from sourcing to delivery</li>
                              <li>Access to multiple global origins and flexible supply planning</li>
                              <li>Full quality certification and shipment traceability</li>
                              <li>Customized solutions for institutional food buyers</li>


                            </ul>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-ef6a980 sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="ef6a980"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div
                      className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3438f72 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="3438f72"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <section
                          className="elementor-section elementor-inner-section elementor-element elementor-element-1037370 elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id={1037370}
                          data-element_type="section"
                        >
                          <div className="elementor-container elementor-column-gap-no">
                            <div
                              className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-69b8ab0 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                              data-id="69b8ab0"
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                  className="elementor-element elementor-element-c129dd0 sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="c129dd0"
                                  data-element_type="widget"
                                  data-widget_type="image.default"
                                >
                                  <div className="elementor-widget-container">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={620}
                                      height={636}
                                      src="/img/services/Untitled-2-01.png"
                                      className="attachment-full size-full wp-image-19031"
                                      alt=""
                                      srcSet="/img/services/Untitled-2-01.png"
                                      sizes="(max-width: 620px) 100vw, 620px"
                                    />{" "}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-d1c73ce sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                              data-id="d1c73ce"
                              data-element_type="column"
                            >
                              <div className="elementor-widget-wrap elementor-element-populated">
                                <div
                                  className="elementor-element elementor-element-8dd5aef no-title sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="8dd5aef"
                                  data-element_type="widget"
                                  data-widget_type="image.default"
                                >
                                  <div className="elementor-widget-container">
                                    <img
                                      loading="lazy"
                                      decoding="async"
                                      width={780}
                                      height={885}
                                      src="/img/services/Untitled-1-01.png"
                                      className="attachment-full size-full wp-image-19035"
                                      alt=""
                                      srcSet="/img/services/Untitled-1-01.png"
                                      sizes="(max-width: 780px) 100vw, 780px"
                                    />{" "}
                                  </div>
                                </div>
                                <div
                                  className="elementor-element elementor-element-2b1beae sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                                  data-id="2b1beae"
                                  data-element_type="widget"
                                  data-widget_type="spacer.default"
                                >
                                  <div className="elementor-widget-container">
                                    <div className="elementor-spacer">
                                      <div className="elementor-spacer-inner" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </section>
                      </div>
                    </div>
                  </div>
                </section>
                {/* <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-9b1b88d elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="9b1b88d"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-143bf5f sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="143bf5f"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-e2766d5 sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="e2766d5"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section> */}
                {/* <section
                  className="elementor-section elementor-top-section elementor-element elementor-element-3e260fc elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                  data-id="3e260fc"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ac7aea5 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                      data-id="ac7aea5"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="elementor-element elementor-element-960b455 elementor-widget-divider--view-line sc_fly_static elementor-widget elementor-widget-divider trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="960b455"
                          data-element_type="widget"
                          data-widget_type="divider.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-divider">
                              <span className="elementor-divider-separator"></span>
                            </div>
                          </div>
                        </div>
                        <div
                          className="elementor-element elementor-element-25837e2 sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
                          data-id="25837e2"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section> */}





              </div>
            </div>
            {/* .entry-content */}
          </article>
        </div>
      </div>
    </div>


  )
}
